import { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { endpoints } from '~/constants/endpoints';
import store from '~/store';
import { actions as actionsLoading } from '~/store/modules/_ui/loading';
import { Status } from '~/store/modules/_ui/loading/duck';
import { getSelectedTabPermission } from '~/store/modules/tabs/selectors';
import axios from 'axios';
import { useAuthStore } from '~/store/modules/auth/useAuthStore';


const changeLoading = (status: Status) => {
  store.dispatch(
    actionsLoading.setLoading({
      status,
    }),
  );
};

const LOADING_IGNORED_ENDPOINTS = [endpoints.productionPlanning.importingLog];

function shouldSetLoading(config: InternalAxiosRequestConfig) {
  const isAsync = config?.headers?.['X-Is-Async-Loading'] === 'true';
  return !!config.url && !LOADING_IGNORED_ENDPOINTS.includes(config.url) && !isAsync;
}

export default {
  onResponse: async (responseParam: AxiosResponse<any>) => {
    changeLoading('idle');
    return responseParam;
  },
  onRequest: async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    if (config?.headers) {
      if (!config.url?.includes('/connect/token')) {
        config.headers.Authorization = useAuthStore.getTokenToHeader();
      }

      const permissionName = getSelectedTabPermission(store.getState());
      if (permissionName) config.headers['Permission-Name'] = permissionName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

      if (shouldSetLoading(config)) changeLoading('fetching');
    }

    return config;
  },
  onRequestStatus: (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    if (config?.headers) {
      config.headers.Authorization = useAuthStore.getTokenToHeader();
    }
    return config;
  },
  onResponseApiSession: async (responseParam: AxiosResponse<any>) => {
    changeLoading('idle');
    return responseParam;
  }, 
  onError: async (error: any) => {
    changeLoading('idle');

    try {
      return await useAuthStore.handleAxiosError(error, axios);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
